import { __spreadArray } from "tslib";
import { createBrowserHistory, createMemoryHistory } from 'history';
import { updateReferrer } from '@wix/da-bi/pkg/referrer';
import { duperbrowseHistoryChanged, historyChanged } from './actions';
import { isDuperbrowseLocation } from '../../Duperbrowse/redux/helpers';
function createHistory() {
    if (typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
        return createMemoryHistory();
    }
    else {
        return createBrowserHistory();
    }
}
var baseHistoryInstance = createHistory();
function filteredHistoryListen(listener) {
    return baseHistoryInstance.listen(function (location, action) {
        // ignore all duperbrowse locations
        if (isDuperbrowseLocation(location)) {
            return;
        }
        listener(location, action);
    });
}
// This is a weird special case that allows us to avoid sending history
// events for duperbrowse urls, in particular to stop react-router from
// getting confused while duper is active.
var routerSafeHistory = new Proxy(baseHistoryInstance, {
    get: function (target, prop, receiver) {
        if (prop === 'listen') {
            return filteredHistoryListen;
        }
        // try not to fuck up other props
        var targetProp = Reflect.get(target, prop, receiver);
        if (typeof targetProp === 'function') {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return targetProp.call.apply(targetProp, __spreadArray([target], args, false));
            };
        }
        return targetProp;
    },
});
export function configureHistoryListener(store) {
    var unlisten = baseHistoryInstance.listen(function (location, action) {
        updateReferrer();
        isDuperbrowseLocation(location)
            ? store.dispatch(duperbrowseHistoryChanged(location, action))
            : store.dispatch(historyChanged(location, action));
    });
    return unlisten;
}
export default baseHistoryInstance;
export { routerSafeHistory };
//# sourceMappingURL=history.js.map